import {useState} from "react";
import {Link} from "react-router-dom";

import styles from "../../styles/Work.module.scss";

const Project = ({title, data, index, image}) => {
  const [changebg, setChangebg] = useState(false);

  return (
    <Link
      to={`/project/${title}`}
      className={index % 2 === 0 ? styles.leftproject : styles.rightproject}
      onMouseEnter={() => {
        setChangebg(true);
      }}
      onMouseLeave={() => {
        setChangebg(false);
      }}
    >
      <div className={styles.picture}>
        <div
          style={{
            backgroundImage: changebg
              ? `linear-gradient(
             to bottom,
             rgba(0, 0, 0, 0.52),
             rgba(0, 0, 0, 0.73)
           ),url(${image}`
              : `url(${image})`,
          }}
        />
        <img src={image} alt="project pic" />
        {changebg && <p>View project</p>}
      </div>
      <div>
        <h6>{title}</h6>
        <p>{data}</p>
        <button>View Project</button>
      </div>
    </Link>
  );
};

export default Project;
